// Thin client for the skrl API (server/). In development the CRA dev server
// proxies /api to it (see "proxy" in package.json).
export class ApiError extends Error {
  constructor(status, code, data) {
    super(data?.message || code);
    this.status = status;
    this.code = code;
    this.field = data?.field;
  }
}

async function request(method, path, body) {
  const res = await fetch('/api' + path, {
    method,
    credentials: 'same-origin',
    headers: body !== undefined ? { 'Content-Type': 'application/json' } : undefined,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  let data = null;
  try { data = await res.json(); } catch { /* empty body */ }
  if (!res.ok) throw new ApiError(res.status, data?.error || 'request_failed', data);
  return data;
}

const enc = encodeURIComponent;

export const api = {
  // auth + account
  me: () => request('GET', '/me'),
  login: (email, password) => request('POST', '/auth/login', { email, password }),
  register: fields => request('POST', '/auth/register', fields),
  demo: tier => request('POST', '/auth/demo', { tier }),
  logout: () => request('POST', '/auth/logout', {}),
  updateMe: patch => request('PATCH', '/me', patch),
  changePassword: (current, next) => request('POST', '/me/password', { current, next }),

  // signed-in creator's store
  store: () => request('GET', '/store'),
  create: (coll, item) => request('POST', `/store/${coll}`, { item }),
  patch: (coll, id, patch) => request('PATCH', `/store/${coll}/${enc(id)}`, { patch }),
  remove: (coll, id) => request('DELETE', `/store/${coll}/${enc(id)}`),
  reorderPages: ids => request('PUT', '/store/pages/order', { ids }),
  settings: patch => request('PATCH', '/store/settings', { patch }),
  connection: (key, patch) => request('PATCH', `/store/connections/${enc(key)}`, { patch }),
  pref: (key, value) => request('PUT', `/store/prefs/${enc(key)}`, { value }),
  tier: tier => request('PUT', '/store/tier', { tier }),
  cancelPlan: () => request('POST', '/store/cancel', {}),
  generation: (item, image) => request('POST', '/store/generations', { item, image }),
  getGeneration: id => request('GET', `/store/generations/${encodeURIComponent(id)}`),
  aiStatus: () => request('GET', '/store/ai-status'),
  ticket: (subject, priority) => request('POST', '/store/tickets', { subject, priority }),

  // public storefront
  publicStore: handle => request('GET', `/public/stores/${enc(handle)}`),
  checkout: (handle, body) => request('POST', `/public/stores/${enc(handle)}/checkout`, body),
  track: (handle, body) => request('POST', `/public/stores/${enc(handle)}/track`, body).catch(() => {}),
};
